import React from 'react';
import { useModalContentFactory } from './modalContentFactory';

export const SiteSettingsModal = () => {
    const { componentsWithProps } = useModalContentFactory();

    return (
        <>
            {componentsWithProps !== null && (
                <div className="site-settings-overlay__modal js-site-settings-overlay__modal">
                    {componentsWithProps.map(
                        ({ component: Component, props }, index) => (
                            <Component key={index} {...props} />
                        )
                    )}
                </div>
            )}
        </>
    );
};
